import { useCallback } from 'react';

import { useTrackChangedVideoPlaybackRate } from '@air/analytics';

import { usePlayerStore } from '../components/PlayerContextProvider';

export const usePlayerPlaybackChange = () => {
  const id = usePlayerStore((state) => state.id);
  const videoElement = usePlayerStore((state) => state.videoElement);
  const setPlaybackRate = usePlayerStore((state) => state.setPlaybackRate);
  const { trackChangedVideoPlaybackRate } = useTrackChangedVideoPlaybackRate();

  const onPlayerPlaybackChange = useCallback(
    (playbackRate: number) => {
      if (videoElement) {
        if (playbackRate > 0) {
          videoElement.playbackRate = playbackRate;
        }
        setPlaybackRate(playbackRate);

        trackChangedVideoPlaybackRate({
          id,
          speed: playbackRate,
        });
      }
    },
    [videoElement, id, trackChangedVideoPlaybackRate, setPlaybackRate],
  );

  return { onPlayerPlaybackChange };
};
